import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseFetchReportData = (url, params=null) => {
  const [data, setData] = useState([]);

  const [dataLoading, setDataLoading] = useState(true);


  async function getData() {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { params });
       setData(res?.data?.data || []) 
       setDataLoading(false);
      
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  }
  useEffect(() => {
    getData();
  }, [url, JSON.stringify(params)]);

  return { data, getData , dataLoading };
};

export default UseFetchReportData;